import React, { ReactNode } from 'react';
import { twClasses, combineClasses } from '../styles/tailwind-utils';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  fullWidth?: boolean;
}

const PageContainer: React.FC<PageContainerProps> = ({ 
  children, 
  className = '',
  fullWidth = false
}) => {
  const baseClasses = fullWidth ? 'w-full' : twClasses.pageContainer;
  
  return (
    <div className={combineClasses(baseClasses, className)}>
      {children}
    </div>
  );
};

export default PageContainer; 